const getWLCookieDomain = (rootState) => rootState.config.service.common.authtkt.wl_cookie_domain;

export default getWLCookieDomain;
